const PHI = (1 + Math.sqrt(5)) / 2;

function goldenSpiralPath() {
  const points: string[] = [];
  const turns = 4.15 * Math.PI;
  const steps = 280;
  for (let index = 0; index <= steps; index += 1) {
    const theta = (turns * index) / steps;
    const radius = 7.5 * PHI ** ((2 * theta) / Math.PI);
    const x = 610 + radius * Math.cos(theta);
    const y = 360 + radius * Math.sin(theta);
    points.push(`${index === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`);
  }
  return points.join(" ");
}

const PATH = goldenSpiralPath();

export function FibonacciSpiral({ className = "" }: { className?: string }) {
  return (
    <svg
      className={`fibonacci-spiral ${className}`}
      viewBox="0 0 1000 720"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="xMidYMid slice"
    >
      <path d={PATH} />
    </svg>
  );
}
